<template>
  <v-form
    ref="form"
    v-model="valid"
    class="form"
    @submit.prevent="onSubmit"
  >
    <!-- data-testids below are used by Vanta/Uptrend transactions -->
    <DpplTextField
      v-model="email"
      label="Email"
      :rules="emailRules"
      validate-on="blur"
      data-testid="login-email-input"
      has-details
      @input="validateEmailFormat"
      @change="trimEmail"
    />
    <DpplNewButton
      type="submit"
      color="primary"
      data-testid="login-submit-button"
      class="w-100 mt-1 text-button-2"
      :height="40"
      :disabled="loading || !valid"
    >
      Continue
    </DpplNewButton>
  </v-form>
</template>

<script setup>
import { ref, computed } from 'vue';
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import validation from '@/helpers/validation';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  trimEmail: {
    type: Function,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['submitCheck', 'update:model-value']);

const emailRules = ref(validation.emailRules());
// null until the field is validated, which with validate-on="invalid-input" only happens on blur.
const valid = ref(null);
const form = ref(null);

const onSubmit = async () => {
  const result = await form.value.validate();
  if (result.valid) emits('submitCheck');
};

const email = computed({
  get: () => props.modelValue,
  set: (value) => emits('update:model-value', value),
});

const validateEmailFormat = () => {
  const currentEmailValid = emailRules.value.every((rule) => rule(email.value) === true);

  if (currentEmailValid) {
    form.value.validate();
  } else form.value.resetValidation();
};
</script>

<style lang="less" scoped>
.form {
  width: 100%;
}
</style>
